import { Fragment, useEffect, useRef, createRef, memo } from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import { Switch } from "@headlessui/react";
//
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}


const RecepcionGrid = ({ filteredData = [], handleGridInput = () => {}, handleChangeTextbox = () => {}, textHabilitados }) => {    
    useEffect(() => {
      document.addEventListener('wheel', (e) => handleWheel(e))
      return () => {
        document.removeEventListener('wheel', (e) => handleWheel(e))
      }
    }, [])
  return (
    
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 bg-secundarioMira rounded-sm shadow-sm ">
              <table className="min-w-full divide-y divide-grisMira p-5  shadow-sm shadow-grisMira">
                
                <thead className="sticky top-0 z-10 bg-secundarioMira ">
                  <tr className="w-full divide-x divide-grisMira ">
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 "
                    >
                      ID PRODUCTO
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira"
                    >
                      NOMBRE
                    </th>
                    
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira"
                    >
                      REGISTRADO
                    </th>
                    
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira"
                    >
                      RECIBIDO
                    </th>

                    {/*
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira"
                    >
                      FALTANTE
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira"
                    >
                      TOTAL DE FALTANTE
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira"
                    >
                      SOBRANTE
                    </th>
                    */}
                    
                  </tr>
                </thead>
                

                <tbody className="divide-y divide-grisMira bg-primarioMira w-full">
                  {filteredData?.map((element, index) => (
                        <tr
                          key={index}
                          className={"divide-x divide-grisMira"}
                        //className={classNames(isSelectCargo ? 'bg-secundario' : undefined, alumnoIdx === 0 ? 'border-gray-300' : 'border-gray-200', 'border-t hover:bg-secundarioMira transition-all duration-200 ease-in ')}
                        >
                          <td className=" whitespace-nowrap p-4 text-sm text-white text-center">
                            
                              <p className={"m-auto"}>{element.id}</p>
                            
                          </td>
                          <td className=" whitespace-nowrap p-4 text-sm text-white ">
                            {element.name}
                          </td>
                          <td className=" whitespace-nowrap p-4 text-sm text-white ">
                            {element.registrado}
                          </td>
                          {/*
                          <td className="  whitespace-nowrap p-4 text-sm text-white  text-center">
                            {element.Existencia}
                          </td>
                          */}
                          <td className="   text-black   whitespace-nowrap  text-sm   text-center p-2">
                              <input
                                type="number"
                                disabled={textHabilitados}
                                name={"recibido" + index}
                                autoComplete={false}
                                className={"w-[50%] |mx-auto rounded-md bg-gray-100 text-center"}
                                onBlur={(e) => handleGridInput(e, index)} // evento on change poner la suma para no equivocar los indices o guardar el indice editado para nno equivocarlo handleGridInput = (e, Idx) 
                                onChange={(e) =>{ 
                                  handleChangeTextbox(e, index);
                                  //handleGridInput(e, index)
                                }}
                                // value={element.Recuento}
                              ></input>
                          </td>
                          {/*
                          <td className="  whitespace-nowrap p-4 text-sm text-white  text-center">
                            {element?.Faltante}
                          </td>
                          <td className="  whitespace-nowrap p-4 text-sm text-white  text-center">
                            {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(element?.TotalFaltante || 0)}
                          </td>
                          <td className="  whitespace-nowrap p-4 text-sm text-white  text-center">
                                                                                {element?.Sobrante}
                          </td>
                          */}
                        </tr>
                  ))}
                </tbody>
              </table>
            </div>
        
  );
};

const handleWheel = (e) => {
    console.log(e)
    if(e.target.type === "number"){
        e.target.blur();
    }
}

export default memo(RecepcionGrid);